import { Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Paginate from '../components/Paginate';
import ContactForm from '../components/ContactForm';
import { useGetProductsQuery } from '../slices/productsApiSlice';
import ProductOnLine from '../components/ProductOnLine';
import { useTranslation } from 'react-i18next';

const HomeScreenOnLine = () => {
  const { pageNumber, keyword } = useParams();
  const { t } = useTranslation();

  const { data, isLoading, error } = useGetProductsQuery({
    pageNumber,
    keyword,
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>
          {error?.data?.message || error.error}{' '}
        </Message>
      ) : (
        <>
          <div className='page-heading'>
            <h1>{t('homeOnlineTitle')}</h1>
            <p>Apprenez à votre rythme avec nos formations en ligne.</p>
          </div>
          <Row>
            {data.products.map(
              (product) =>
                product.type === 1 && (
                  <Col
                    key={product._id}
                    sm={12}
                    md={6}
                    lg={4}
                    xl={3}
                    className='product-col'
                  >
                    <ProductOnLine product={product} />
                  </Col>
                )
            )}
          </Row>
          <Paginate
            pages={data.pages}
            page={data.page}
            keyword={keyword ? keyword : ''}
          />
          <br />
          <br />
          <ContactForm />
        </>
      )}
    </>
  );
};

export default HomeScreenOnLine;
